<button
  type="button"
  class="bv-color-swatch"
  [class.bv-color-swatch--empty]="!value"
  [class.bv-color-swatch--disabled]="disabled"
  [disabled]="disabled"
  [style.background]="value || ''"
  [bvMenuTriggerFor]="paletteMenu"
  [attr.aria-label]="labelKey | translate"
  >
  @if (!value) {
    <span class="bv-color-swatch__placeholder">+</span>
  }
</button>

<bv-menu #paletteMenu>
  <div class="bv-color-swatch__panel" (click)="$event.stopPropagation()">
    @if (!showCustom) {
      <div class="bv-color-swatch__grid">
        @for (c of palette; track trackByHex($index, c)) {
          <button
            type="button"
            class="bv-color-swatch__cell"
            [class.bv-color-swatch__cell--active]="value === c.hex"
            [style.background]="c.hex"
            [attr.title]="c.key | translate"
            (click)="pick(c.hex)"
          ></button>
        }
      </div>
      @if (filteredRecent.length) {
        <div class="bv-color-swatch__grid bv-color-swatch__grid--recent">
          @for (hex of filteredRecent; track trackByString($index, hex)) {
            <button
              type="button"
              class="bv-color-swatch__cell bv-color-swatch__cell--custom"
              [style.background]="hex"
              [attr.title]="hex"
              (click)="pick(hex)"
            ></button>
          }
        </div>
      }
      <div class="bv-color-swatch__row">
        <button type="button" class="bv-color-swatch__action" (click)="enterCustom()">
          {{ "CHIP_COLOR_CUSTOM" | translate }}…
        </button>
        @if (allowClear && value) {
          <button
            type="button"
            class="bv-color-swatch__action bv-color-swatch__action--danger"
            (click)="clear()"
            >
            {{ "CLEAR" | translate }}
          </button>
        }
      </div>
    }

    @if (showCustom) {
      <div class="bv-color-swatch__row bv-color-swatch__row--custom">
        <input
          type="color"
          class="bv-color-swatch__native"
          [value]="customInput || '#000000'"
          (change)="onNativeColorChange($event)"
          />
        <input
          type="text"
          class="bv-color-swatch__hex"
          [(ngModel)]="customInput"
          [class.bv-color-swatch__hex--error]="customError"
          [placeholder]="'HEX_VALUE' | translate"
          maxlength="7"
          (keydown.enter)="commitCustom()"
          />
      </div>
      <div class="bv-color-swatch__row">
        <button type="button" class="bv-color-swatch__action" (click)="leaveCustom()">
          {{ "BACK" | translate }}
        </button>
        <button type="button" class="bv-color-swatch__action bv-color-swatch__action--primary" (click)="commitCustom()">
          {{ "CONFIRM" | translate }}
        </button>
      </div>
    }
  </div>
</bv-menu>
